import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Colors } from "../Colors/Colors";

function ConfirmLeavePageDialog({ handleCancel, handleConfirm }) {
  return (
    <Dialog
      title={"Confirm"}
      onClose={handleCancel}
    >
      <p style={{ margin: "25px", textAlign: "center", fontSize: 16 }}>
        You have unsaved changes. Do you want to leave without saving?
      </p>
      <DialogActionsBar>
        <Button
          className="k-button"
          name={`btnLeaveDialogNo`}
          style={{ backgroundColor: Colors.secondary }}
          onClick={handleCancel}
        >
          No
        </Button>
        <Button
          className="k-button"
          name={`btnLeaveDialogYes`}
          style={{ backgroundColor: Colors.error }}
          onClick={handleConfirm}
        >
          Yes
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
}

export default ConfirmLeavePageDialog;
